export default {
	fansAnalysis:{},
	fansCount:{},
	list:{
		list:[]
	}
}



// WEBPACK FOOTER //
// ./src/store/mp/wechat/fans/state.js